import {
  AdminPanelLogo,
  useMediaQuery,
  useTheme,
} from '@backoffice-frontend/patterns'

export const LoginLayout = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div
      css={{
        flexDirection: isMobile ? 'column' : 'row',
        display: 'flex',
        backgroundColor: theme.semantic.ColorSurfaceDefault,
      }}
    >
      <div
        css={{
          minHeight: '100vh',
        }}
      >
        <div
          css={{
            height: '100vh',
            display: 'flex',
            width: isMobile ? '100%' : '601px',
            padding: isMobile
              ? '60px var(--space-5, 20px)'
              : '60px var(--space-0, 0)',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <AdminPanelLogo height={isMobile ? 12 : 20} css={{ width: 250 }} />
          <div
            css={{
              display: 'flex',
              flex: 1,
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            {children}
          </div>
        </div>
      </div>
      {isMobile ? null : (
        <div
          css={{
            width: '100%',
            borderRadius: '16px 0 0 16px',
            backgroundImage: `url(/assets/images/admin-login.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      )}
    </div>
  )
}
